import React, {Component} from "react";
import {FormattedMessage} from "react-intl";
import axios from "axios";
import {RESOURCE_BASE_URL} from "../../../configuration";

class ProductionTitleBar extends Component {

    exportToCsv = () => {
        let fileDate = new Date();
        let editMinutes = fileDate.getMinutes();
        if (editMinutes < 10) {
            editMinutes = "0" + editMinutes;
        }
        let axiosConfig = {
            headers: {
                'Content-Type': 'application/json;charset=UTF-8',
                "Access-Control-Allow-Origin": "*",
            }
        };

        axios.get(RESOURCE_BASE_URL + 'api/admin/production/export-production', axiosConfig)
            .then((res) => {
                // let production = this.base64ToArrayBuffer(res.data);

                this.saveByteArray("Production_list_" + fileDate.getFullYear() + ("0" + (fileDate.getMonth() + 1)).slice(-2) + ("0" + fileDate.getDate()).slice(-2)
                    + fileDate.getHours() + editMinutes + ".csv", res.data);
                // console.log("cvs data ", res.data);
            })
            .catch((err) => {
                console.log("[API] ERROR: cvs data  ", err);
            });
    };

    base64ToArrayBuffer = (base64) => {
        // let binaryString = window.atob(base64);
        let binaryLen = base64.length;
        let bytes = new Uint8Array(binaryLen);
        for (let i = 0; i < binaryLen; i++) {
            let ascii = base64.charCodeAt(i);
            bytes[i] = ascii;
        }
        return bytes;
    };

    saveByteArray = (reportName, byte) => {
        // let bytes = new Uint8Array(byte);
        let blob = new Blob([byte], {type: "data:text/csv;charset=utf-8"});
        let link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        let fileName = reportName;
        link.download = fileName;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    render() {
        return (
            <div>
                <div className="row">
                    <div className="title-1 text-align-left">
                        &nbsp;&nbsp;出荷一覧
                    </div>
                </div>
                <hr/>
                <div className="row">
                    <div className="col-md-2">
                        <label>商品番号検索</label>
                    </div>
                    <div className="col-md-3 custom-col-10 ">
                        <input className="form-control search-input color-text" onChange={this.props.setSearchText}/>
                    </div>
                    <div className="col-md-4 custom-col-4 no-padding-right">
                        {/* <button className="btn btn-warning pull-right " id="csv-btn-1">
                            生産完了一覧印刷
                        </button>*/}
                    </div>
                    <div className="col-md-3 custom-col-12 no-padding-left">
                        <button className="btn btn-warning pull-right production-download-btn" onClick={this.exportToCsv}>
                            {/*生産完了一覧ダウンロード*/}
                            出荷一覧 ダウンロード
                        </button>
                    </div>
                </div>
                <div className="row">
                    {/* &nbsp;&nbsp;&nbsp;*/}&nbsp;&nbsp;<label className="production-table-item-count">件数
                    :&nbsp;{this.props.totalItemCount}</label>
                </div>
            </div>

        );
    }
}

export default ProductionTitleBar;



// WEBPACK FOOTER //
// ./src/components/Admin/ProductionCompletionList/ProductionTitleBar.js